import React from "react";
import Skills from "./Skills/Skills";

const About = () => {
  return (
    <section className="py-8">
      <div className="flex flex-wrap md:px-4">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4">Who am I?</h3>
            <p className="text-sm text-gray-400 leading-6 mb-3">
              I am a dedicated and detail-oriented professional with
              4+ years of experience in mobile and web application development.
              Specializing in cross-platform solutions using Flutter,
              I have a strong background in backend integration,
              state management, and advanced features like image
              processing and AI-driven technologies. My expertise spans
              across modern tools and frameworks, including Firebase,
              Node.js, TypeScript, MongoDB, and AWS services like Amplify and S3.
            </p>
            <p className="text-sm text-gray-400 leading-6 mb-3">
              I thrive on crafting user-friendly, scalable applications
              while collaborating with teams to deliver high-quality results.
              Passionate about innovation and solving real-world problems,
              I am continually enhancing my skills to stay at the forefront
              of technology.

              Outside of work, I enjoy exploring cutting-edge technologies
              and contributing to open-source projects, driven by a love for
              learning and growth.
            </p>
          </div>
          <Skills />
        </div>
      </div>
    </section>
  );
};

export default About;
